import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { types, getParent } from 'mobx-state-tree';
import { ALLOCATION_METHOD, BILL_FREQUENCY, PAID_BY_TO_VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import moment from 'moment';
export const UtilityTypeModel = types.model({
  utilityTypeId: types.string,
  utilityTypeName: types.string,
  isCustom: types.optional(types.boolean, false)
}).actions(store => {
  return {
    setUtilityTypeId(val) {
      if (store.isCustom) store.utilityTypeId = val;
    }
  };
});
export const UtilityProviderModel = types.model('UtilityProviderModelForLegacyConfig', {
  id: types.maybeNull(types.string),
  utilityProviderId: types.optional(types.string, ''),
  utilityProviderName: types.optional(types.string, ''),
  website: types.optional(types.maybeNull(types.string), ''),
  billsDownloadNeeded: types.optional(types.boolean, false),
  isCustom: types.optional(types.boolean, false),
  isAppAutomationEnabled: types.maybeNull(types.boolean),
  // Must be declared: MST drops properties absent from the model, so an undeclared
  // scraperProviderKey never reaches the credential gate even when the API sends it.
  scraperProviderKey: types.maybeNull(types.string),
  // NOTE: Used only for new utility template creation
  utilities: types.maybeNull(types.array(UtilityTypeModel))
}).actions(store => {
  return {
    setUtilityProviderName(val) {
      if (store.isCustom) store.utilityProviderName = val;
    },
    setWebsite(val) {
      if (store.isCustom) store.website = val;
    },
    setUtilityProviderId(val) {
      if (getParent(store).id === 'NEW_UTILITY_TEMPLATE' && store.isCustom) store.utilityProviderId = val;
    },
    parseProviderFromSearch(data) {
      var _data$scraperProvider;
      store.utilityProviderId = data === null || data === void 0 ? void 0 : data.id;
      store.utilityProviderName = data === null || data === void 0 ? void 0 : data.name;
      store.website = data === null || data === void 0 ? void 0 : data.website;
      store.billsDownloadNeeded = data === null || data === void 0 ? void 0 : data.billsDownloadNeeded;
      store.isCustom = data === null || data === void 0 ? void 0 : data.isCustom;
      store.isAppAutomationEnabled = data === null || data === void 0 ? void 0 : data.isAppAutomationEnabled;
      store.scraperProviderKey = (_data$scraperProvider = data === null || data === void 0 ? void 0 : data.scraperProviderKey) !== null && _data$scraperProvider !== void 0 ? _data$scraperProvider : null;
      store.utilities = (data === null || data === void 0 ? void 0 : data.utilities) !== null ? data === null || data === void 0 ? void 0 : data.utilities.map(item => _objectSpread(_objectSpread({}, item), {}, {
        utilityTypeName: item.name
      })) : data === null || data === void 0 ? void 0 : data.utilities;
    },
    setGenericUtilities(data) {
      if (getParent(store).id === 'NEW_UTILITY_TEMPLATE' && store.isCustom) {
        store.utilities = data;
      } else return;
    }
  };
});
export const UtilityTemplateModel = types.model({
  id: types.optional(types.string, 'NEW_UTILITY_TEMPLATE'),
  provider: types.optional(UtilityProviderModel, {}),
  utilityId: types.maybeNull(types.string),
  utilityType: types.maybeNull(types.string),
  utilityTypeId: types.maybeNull(types.string),
  billFrequencyType: types.optional(types.string, BILL_FREQUENCY.Monthly),
  allocationMethod: types.optional(types.string, ALLOCATION_METHOD.ByOccupancy),
  commonAreaDeduction: types.maybeNull(types.number),
  vacantUnitAllocation: types.optional(types.string, VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
  vacantUnitUsage: types.optional(types.string, VACANT_UNIT_USAGE.NoUsage),
  vacantUnitUsageLimit: types.maybeNull(types.number),
  vacantUnitOccupantsCount: types.maybeNull(types.number),
  goodWillDeduction: types.maybeNull(types.optional(types.number, 5)),
  lastUpdateTime: types.optional(types.number, moment().toDate().getTime())
}).actions(store => {
  return {
    setBillFrequencyType(value) {
      store.billFrequencyType = value;
    },
    setAllocationMethod(value) {
      store.allocationMethod = value;
    },
    setCommonAreaDeduction(value) {
      store.commonAreaDeduction = value;
    },
    setVacantUnitAllocation(value) {
      store.vacantUnitAllocation = value;
    },
    setVacantUnitUsage(value) {
      store.vacantUnitUsage = value;
    },
    setVacantUnitUsageLimit(value) {
      store.vacantUnitUsageLimit = value;
    },
    setVacantUnitOccupantsCount(value) {
      store.vacantUnitOccupantsCount = value;
    },
    setGoodWillDeduction(value) {
      store.goodWillDeduction = value;
    },
    // NOTE: Methods only for adding new template
    configureProviderModelForNewTemplate(data) {
      if (store.id !== 'NEW_UTILITY_TEMPLATE') return;
      store.provider.parseProviderFromSearch(data);
    },
    configureUtilityType(data) {
      if (store.id !== 'NEW_UTILITY_TEMPLATE' || !data) return;
      if (data !== null && data !== void 0 && data.isCustom && data.id.startsWith('customUtilityId_')) {
        store.utilityId = data.id;
        store.utilityTypeId = data.id;
        store.utilityType = data.inputName;
        store.vacantUnitUsageLimit = 10;
        store.commonAreaDeduction = 0;
      } else {
        store.utilityId = data.id;
        store.utilityTypeId = data.utilityTypeId;
        store.utilityType = data.utilityTypeName;
      }
    },
    updateProviderModalInitials(data) {
      if (store.id !== 'NEW_UTILITY_TEMPLATE' || !data) return;
      store.allocationMethod = data.defaultAllocationMethod;
      store.vacantUnitAllocation = PAID_BY_TO_VACANT_UNIT_ALLOCATIONS[data.paidBy];
      store.vacantUnitUsage = data.defaultVacantUnitUsage;
      store.vacantUnitUsageLimit = data.defaultVacantUnitUsage === VACANT_UNIT_USAGE.LimitedUsage ? 30 : 10;
      store.commonAreaDeduction = data.cad ? 5 : 0;
    },
    updateUtilityTypeIdForNewCustomUtility(data) {
      // if (store.id !== 'NEW_UTILITY_TEMPLATE' || !store.utilityId.startsWith('customUtilityId_')) return;
      store.utilityId = data.utilityId;
      store.utilityTypeId = data.utilityTypeId;
    }
  };
}).views(store => ({
  get utilityName() {
    return store.utilityType;
  }
}));